import React from 'react';
import { CheckboxContainer, HiddenInput, Checkmark } from './styles';

interface SimpleCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  id?: string;
  name?: string;
  value?: string | number;
}

const SimpleCheckbox: React.FC<SimpleCheckboxProps> = ({
  checked,
  onChange,
  disabled = false,
  id,
  name,
  value
}) => {
  console.log('SimpleCheckbox render:', { checked, id, value });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log('SimpleCheckbox handleChange:', { checked: event.target.checked, id, value });
    onChange(event.target.checked);
  };

  return (
    <CheckboxContainer disabled={disabled}>
      <HiddenInput
        type="checkbox"
        id={id}
        name={name}
        value={value}
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
      />
      <Checkmark checked={checked} disabled={disabled}>
        {checked && (
          <svg width="12" height="9" viewBox="0 0 12 9" fill="none">
            <path
              d="M10.5 1L4.5 7L1.5 4"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </Checkmark>
    </CheckboxContainer>
  );
};

export default SimpleCheckbox;
